'use strict';

angular.module('portal.services', [])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // portal routings
            // services tab
            .state('portal.menus.service', {
                abstract: true,
                templateUrl: paths.app + 'services/components/service/service.html',
                controller: 'PortalService',
                params: {
                    id: null,
                    service: null
                }
            })
            .state('portal.menus.service.inspections', {
                url: '/service/:id/inspections',
                templateUrl: paths.app + 'services/components/inspections/inspections.html',
                controller: 'PortalServiceInspections',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.clinicians', {
                url: '/service/:id/clinicians',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.vouchers', {
                url: '/service/:id/vouchers',
                templateUrl: paths.app + 'services/components/vouchers/vouchers.html',
                controller: 'PortalVouchers',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
    }])
;